<!-- used only with the oprator redirection flow-->
<template>
  <v-row class="mx-0 mt-5 mb-4">
    <v-col v-if="loaded">
      <v-row>
        <v-col class="pt-0">
          <v-layout align-center mb-5 class="successTitle">
            <div>
              <v-icon x-large color="success">{{ pendingIcon }}</v-icon>
            </div>
            <v-flex mx-2 class="title" mt-1>
              <label v-html="pendingMsg" />
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            elevation="0"
            block
            class="mainButton"
            :rounded="templateConfig.isButtonRounded"
            :loading="loading"
            @click="redirectToMerchantPage()"
          >
            <span v-html="pendingBtnText" v-if="!loading"></span>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else>
      <MainLoader />
    </v-col>
  </v-row>
</template>

<script>
import { mdiCheckCircleOutline } from '@mdi/js'; //named import for Alert Icon.
import { mapState } from 'vuex';
import MainLoader from '../../Shared/components/MainLoader.vue';

export default {
  components: { MainLoader },
  computed: {
    ...mapState(['templateConfig', 'merchantConfig']),
    pendingMsg() {
      return this.$translate(`RESPONSECODE_${this.pendingData.responseCode}`);
    },
    pendingBtnText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.failureBtn; // TODO: create config in dashboard for pending btn text
    },
  },
  data() {
    return {
      loading: false,
      pendingData: {},
      loaded: false,
      pendingIcon: mdiCheckCircleOutline,
    };
  },
  methods: {
    redirectToMerchantPage() {
      window.location.replace(this.pendingData.redirectUrl);
    },
  },
  async created() {
    let response = await this.$http.get(
      `/Payment/GetPaymentConfirmationResponse/sub?OperationStatusCode=pending`
    );
    // let response = {
    //   data: {
    //     customerAccountNumber: '123',
    //     redirectUrl:
    //       'https://www.nour-redirect.com?operationStatusCode=0&subscriptionContractId=53&subscriptionContractStatus=&customerAccountNo=123&transactionId=&paymentTransactionStatusCode=&operatorCode=60201&msisdn=201110465548&productCatalogName=100Points&productId=123&nextPaymentDate=&language=1&errorMessage=&checkoutId=0HMD7CULE5THS:00000049&signature=0oa70WuefiddqLjqlTlp:6e57d84aaabc37ec64bf75df9c153d3aca513073b6f41f8f6e2877631fdab9b8',
    //     statusCode: 1,
    //     responseCode: 0,
    //   },
    // };
    this.pendingData = response.data;
    this.loaded = true;
  },
};
</script>
